import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import _orderBy from 'lodash/orderBy';
import { useTranslation } from 'react-i18next';
import { Icon } from '@pwc/pwc-deals-ui';
import { CommentTarget } from '@pwc/pwc-deals-web-common';
import FieldCommentWrapper from 'common/components/FieldCommentWrapper';
import { getTranslationForDefaultTag } from 'common/services/tagsI18n';
import styles from './TagList.module.scss';

import './TagList.scss';

const TagList = ({
  tags,
  testId,
  iconSize = 18,
  isCommentingAllowed = false,
}) => {
  const { t } = useTranslation();

  if (tags && tags.length === 0) {
    return null;
  }

  let tagsListObject = tags;
  if (typeof tags?.[0] === 'string') {
    tagsListObject = tags.map((x, i) => ({ id: i, text: x }));
  }

  const orderedTags = _orderBy(
    tagsListObject,
    [(tag) => tag?.text.toLowerCase()],
    ['asc']
  ).map((tag) => ({
    ...tag,
    displayText: getTranslationForDefaultTag(tag?.text, t),
  }));

  return (
    <div className="tags-list-container" data-testid={testId}>
      <div>
        <Icon
          name="tag"
          className="fill tag-icon"
          width={iconSize}
          data-testid="draft-icon"
        />
      </div>

      {isCommentingAllowed ? (
        <FieldCommentWrapper
          fieldKey={CommentTarget.Tags}
          className="no-padding-right"
        >
          <div className={classNames('tags', styles.isolated)}>
            {orderedTags.map((tag, i) => {
              const isLast = i === orderedTags.length - 1;
              return (
                <span
                  // eslint-disable-next-line react/no-array-index-key
                  key={`${tag.text}-${i}`}
                  className={classNames('tag-text', {
                    [styles.tagItemIsolated]: !isLast,
                  })}
                  data-testid="tag"
                >
                  {tag.displayText}
                  {isLast ? '' : ','}
                </span>
              );
            })}
          </div>
        </FieldCommentWrapper>
      ) : (
        <div className="tags">
          {orderedTags.map((tag, i) => {
            return (
              <span
                // eslint-disable-next-line react/no-array-index-key
                key={`${tag.text}-${i}`}
                className="tag-text"
                data-testid="tag"
              >
                {i ? ', ' : ''}
                {tag.displayText}
              </span>
            );
          })}
        </div>
      )}
    </div>
  );
};

TagList.propTypes = {
  tags:
    PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        text: PropTypes.string,
      })
    ) || PropTypes.arrayOf(PropTypes.string),
  testId: PropTypes.string.isRequired,
};

TagList.defaultProps = {
  tags: [],
};

export default TagList;
